import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <article className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-dark mb-6">
              Privacy Policy
            </h1>
            
            <div className="text-sm text-gray-light mb-8">
              Last updated: 02.12.2025
            </div>
            
            <div className="prose prose-lg max-w-none text-gray-light leading-relaxed space-y-6">
              <p className="text-xl text-gray-medium">
                At Sceptre Slots, we take your privacy seriously. This Privacy Policy explains 
                how we collect, use, disclose, and safeguard your information when you visit our 
                website. Please read this policy carefully to understand our practices regarding 
                your personal data.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Information We Collect</h2>
              
              <p>
                We collect information that you provide directly to us when you use our website. 
                This includes information you provide when you fill out contact forms, subscribe 
                to newsletters, or communicate with us. The types of information we may collect 
                include your name, email address, phone number, and any other information you 
                choose to provide.
              </p>
              
              <p>
                We automatically collect certain information about your device when you access 
                our website, including your IP address, browser type, operating system, access 
                times, and the pages you have viewed directly before and after accessing our 
                website. This information helps us understand how visitors use our site and 
                improve our services.
              </p>
              
              <p>
                We use cookies and similar tracking technologies to track activity on our website 
                and store certain information. Cookies are files with small amounts of data that 
                may include an anonymous unique identifier. You can instruct your browser to 
                refuse all cookies or to indicate when a cookie is being sent.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">How We Use Your Information</h2>
              
              <p>
                We use the information we collect to provide, maintain, and improve our services. 
                This includes responding to your inquiries, sending you newsletters or updates 
                (if you have subscribed), and analyzing how our website is used to enhance user 
                experience.
              </p>
              
              <p>
                We may use your information to communicate with you about our services, respond 
                to your comments and questions, and provide customer support. We also use 
                collected information to detect, prevent, and address technical issues and 
                fraudulent activity.
              </p>
              
              <p>
                We may use aggregated, anonymized data for analytical purposes to understand 
                user behavior and improve our website's functionality and content. This data 
                cannot be used to identify individual users.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Information Sharing and Disclosure</h2>
              
              <p>
                We do not sell, trade, or rent your personal information to third parties. 
                However, we may share your information with trusted service providers who assist 
                us in operating our website, conducting our business, or serving our users, 
                provided these parties agree to keep your information confidential.
              </p>
              
              <p>
                We may disclose your information if required to do so by law or in response to 
                valid requests by public authorities. We may also disclose information to protect 
                our rights, privacy, safety, or property, or that of our users or others.
              </p>
              
              <p>
                In the event of a merger, acquisition, or sale of assets, your information may 
                be transferred as part of that transaction. We will notify you of any such change 
                in ownership or control of your personal information.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Affiliate Relationships</h2>
              
              <p>
                Our website contains affiliate links to online casinos and gambling operators. 
                When you click on these links or register through them, we may receive 
                compensation from the operator. This does not affect the price you pay or the 
                services you receive.
              </p>
              
              <p>
                When you click on affiliate links, you may be redirected to third-party websites 
                that have their own privacy policies. We encourage you to review the privacy 
                policies of any third-party sites you visit, as we are not responsible for their 
                privacy practices.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Data Security</h2>
              
              <p>
                We implement appropriate technical and organizational security measures to protect 
                your personal information against unauthorized access, alteration, disclosure, or 
                destruction. However, no method of transmission over the Internet or electronic 
                storage is 100% secure, and we cannot guarantee absolute security.
              </p>
              
              <p>
                We use industry-standard encryption technologies when transmitting sensitive 
                information. We also limit access to personal information to employees, contractors, 
                and agents who need to know that information to process it on our behalf.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Your Rights</h2>
              
              <p>
                Under UK data protection laws, you have certain rights regarding your personal 
                information. You have the right to access, update, or delete your personal 
                information. You can also object to processing of your personal information, 
                request restriction of processing, or request data portability.
              </p>
              
              <p>
                If you wish to exercise any of these rights, please contact us using the 
                information provided at the end of this policy. We will respond to your request 
                within one month, though this may be extended in certain circumstances.
              </p>
              
              <p>
                You have the right to withdraw consent at any time where we rely on consent to 
                process your personal information. However, this will not affect the lawfulness 
                of any processing carried out before you withdraw your consent.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Data Retention</h2>
              
              <p>
                We retain your personal information only for as long as necessary to fulfill the 
                purposes outlined in this Privacy Policy, unless a longer retention period is 
                required or permitted by law. When we no longer need your information, we will 
                securely delete or anonymize it.
              </p>
              
              <p>
                We may retain certain information for legitimate business purposes, such as 
                maintaining records of transactions, resolving disputes, and enforcing our 
                agreements. We may also retain anonymized data for analytical purposes.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Children's Privacy</h2>
              
              <p>
                Our website is intended for users aged 18 and over only. We do not knowingly 
                collect personal information from children under 18. If you are a parent or 
                guardian and believe your child has provided us with personal information, 
                please contact us immediately, and we will delete such information from our 
                records.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Changes to This Privacy Policy</h2>
              
              <p>
                We may update this Privacy Policy from time to time to reflect changes in our 
                practices or for other operational, legal, or regulatory reasons. We will notify 
                you of any material changes by posting the new Privacy Policy on this page and 
                updating the "Last updated" date.
              </p>
              
              <p>
                We encourage you to review this Privacy Policy periodically to stay informed 
                about how we collect, use, and protect your information. Your continued use of 
                our website after any changes constitutes acceptance of the updated Privacy Policy.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Contact Us</h2>
              
              <p>
                If you have any questions about this Privacy Policy or our data practices, please 
                contact us at:
              </p>
              
              <p className="font-semibold">
                Email: info@sceptreslots.com<br />
                Phone: +44 8147 675 497<br />
                Address: London, United Kingdom
              </p>
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;

